export default __webpack_public_path__ + "static/media/Rup-logo.38a61f63.svg";